import { render, staticRenderFns } from "./PromoBanners.vue?vue&type=template&id=8f62fbfe&scoped=true"
import script from "./PromoBanners.vue?vue&type=script&lang=js"
export * from "./PromoBanners.vue?vue&type=script&lang=js"
import style0 from "./PromoBanners.vue?vue&type=style&index=0&id=8f62fbfe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f62fbfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f62fbfe')) {
      api.createRecord('8f62fbfe', component.options)
    } else {
      api.reload('8f62fbfe', component.options)
    }
    module.hot.accept("./PromoBanners.vue?vue&type=template&id=8f62fbfe&scoped=true", function () {
      api.rerender('8f62fbfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lobby/PromoBanners.vue"
export default component.exports